<div class="video-container">
    <video-in-process
        [job-id]="attachment?.idJobMediaConvert"
        [src]="attachment?.urlAnexo"
        (video-complete)="VideoConvertComplete()"
    >
    </video-in-process>
</div>
